module.exports = __webpack_public_path__ + "static/media/instagram.b6f4e41a.svg";